<template>
  <form @submit.prevent="$emit('search')">
    <div class="flex mb-5">
      <base-input :label="$t('labels.search')" @input="$emit('input', $event)" class="flex-1" v-model="innerValue"/>
      <base-button class="self-center ml-2" icon="search" type="submit"/>
    </div>
  </form>
</template>

<script>
  export default {
    props: ['value', 'search'],
    computed: {
      innerValue: {
        get () {
          return this.value
        },
        set (newName) {
          return newName
        }
      }
    }
  }
</script>

<style scoped>

</style>
